export default "__VITE_ASSET__Ch6FhHMA__"